import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { PageHeader } from "@/components/DashboardShell";
import { StatusPill } from "@/components/brand";
import api from "@/lib/api";

const FILTERS = [
  { key: "pending", label: "Pending" },
  { key: "under_review", label: "Under review" },
  { key: "approved", label: "Approved" },
  { key: "rejected", label: "Rejected" },
  { key: "", label: "All" },
];

export default function AdminApplicants() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("pending");

  const load = useCallback(async () => {
    const { data } = await api.get("/applications", { params: filter ? { status: filter } : {} });
    setItems(data);
  }, [filter]);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    try { await api.patch(`/applications/${id}/status`, { status }); toast.success(`Marked ${status.replace("_", " ")}`); load(); }
    catch { toast.error("Action failed"); }
  };

  return (
    <div>
      <PageHeader index="01" eyebrow="Applicant Queue" title="Driver applications" tag="≤ 48h review SLA" />

      <div className="flex flex-wrap gap-2 mb-6">
        {FILTERS.map((f) => (
          <button key={f.key} onClick={() => setFilter(f.key)} data-testid={`applicant-filter-${f.key || "all"}`}
            className={`px-3.5 py-1.5 font-mono text-[11px] tracking-[0.1em] uppercase border transition-colors ${filter === f.key ? "bg-[#0a0a0a] text-white border-[#0a0a0a]" : "border-gray-300 text-gray-500 hover:border-[#0a0a0a]"}`}>
            {f.label}
          </button>
        ))}
      </div>

      <div className="border border-gray-200 divide-y divide-gray-200" data-testid="applicant-list">
        {items.length === 0 && <div className="px-5 py-10 text-center text-sm text-gray-400">No applications in this view.</div>}
        {items.map((a) => (
          <div key={a.id} className="flex items-center justify-between px-5 py-4 gap-4" data-testid={`applicant-row-${a.id}`}>
            <Link to={`/admin/applicants/${a.id}`} className="min-w-0 flex-1 group">
              <div className="flex items-center gap-3">
                <span className="text-sm font-semibold text-[#0a0a0a] group-hover:text-orange-600">{a.first_name} {a.last_name}</span>
                <StatusPill status={a.status} />
              </div>
              <div className="text-xs text-gray-500 mt-0.5 font-mono">{a.region} · {a.licence_class} · {a.licence_number}</div>
            </Link>
            <div className="flex items-center gap-2 shrink-0">
              {a.status === "pending" && (
                <button onClick={() => setStatus(a.id, "under_review")} data-testid={`review-${a.id}`} className="font-mono text-[11px] tracking-[0.1em] uppercase border border-gray-300 px-3 py-1.5 hover:border-[#0a0a0a]">Review</button>
              )}
              {["pending", "under_review"].includes(a.status) && (
                <button onClick={() => setStatus(a.id, "approved")} data-testid={`approve-${a.id}`} className="font-mono text-[11px] tracking-[0.1em] uppercase bg-[#0a0a0a] text-white px-3 py-1.5 hover:bg-[#262626]">Approve</button>
              )}
              <Link to={`/admin/applicants/${a.id}`} className="font-mono text-[11px] tracking-[0.1em] uppercase text-orange-600 hover:underline">Open →</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
